<app-header-inner></app-header-inner>
<div  class="subheader dark-overlay dark-overlay-2" 
style="padding: 126px 0 2px;min-height: 211px !important;background-image: url('https://s3.eu-central-1.amazonaws.com/heek-media/images/industries/food/food-burger/cover-2.jpg')">
    <div class="container">
      <div class="row">
			<div class="col-12 col-md-6">
				<h1>Gift Card</h1>
			</div>
			
		</div>
	  <div class="subheader-inner">
		
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Gift Card Issuance</li>
          </ol>
        </nav>
      </div>

    </div>
</div>
<section class="section">
    <div class="container">
        <div class="row">
			
			<div class="col-md-12">
				<form [formGroup]="giftcardissuanceForm"  (ngSubmit)="checkOutProccess()">

				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-xl-4 mb-3">
							<label>Card Number</label>
							<div id="creditcarddiv">
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.card_number.errors }">
								<input type="text" name="card_number" id="card_number_gift"
								formControlName="card_number"
								placeholder="1234 5678 9012 3456" maxlength="16" class="visa valid form-control">
								</p>
							</div>
							</div>
							<div class="col-xl-4 mb-3">
								<label>PIN*</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.pin.errors }">
								<input type="text" class="form-control" 
									formControlName="pin"
									placeholder="CVV" value="" pattern="\d*">
								</p>
						    </div>
							<div class="col-xl-4 mb-3">
								<label>Amount*</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.amount.errors }">
								<input type="number" class="form-control"  formControlName="amount" step="0.01">
								</p>
							</div>
							<div class="col-xl-12 mb-3">
								<h4>Billing Details</h4>
							</div>
							<div class="col-xl-4 mb-3">
								<label>Email</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
								<input type="text" class="form-control" formControlName="email" placeholder="Email" value="">
								</p>
						    </div>
							<div class="col-xl-4 mb-3">
								<label>First Name</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.first_name.errors }">
								<input type="text" class="form-control" 
									formControlName="first_name"
									placeholder="First Name" value="">
								</p>
						    </div>
							<div class="col-xl-4 mb-3">
								<label>Middle Name</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.middleName.errors }">
								<input type="text" class="form-control" 
									formControlName="middleName"
									placeholder="Middle Name" value="">
								</p>
						    </div>
							<div class="col-xl-4 mb-3">
								<label>Last Name</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.lastName.errors }">
								<input type="text" class="form-control" 
									formControlName="lastName"
									placeholder="Last Name" value="">
								</p>
						    </div>
							<div class="col-xl-4 mb-3">
								<label>Phone</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.phone.errors }">
								<input type="text" class="form-control" 
									formControlName="phone"
									placeholder="Phone" value="">
								</p>
						    </div>
							<div class="col-xl-4 mb-3">
								<label>Postal</label>
								<p [ngClass]="{ 'has-error': isSubmitted && formControls.postal.errors }">
								<input type="text" class="form-control" 
									formControlName="postal"
									placeholder="Postal" value="">
								</p>
						    </div>
							
							<div class="col-xl-12">
							  <div *ngIf="cardErrorApiCall!=''" class="alert alert-danger">
								  <strong>Error !</strong> {{cardErrorApiCall}}
								</div> 
								<div *ngIf="successmessage!=''" class="alert alert-success">
								  <strong>Success !</strong> {{successmessage}}
								</div>
							</div>
							
							<div class="col-xl-12 mb-3">
								<button *ngIf="!checkOutSpin" type="submit" class="btn-custom primary btn-block">Submit</button>
								<div  *ngIf="checkOutSpin" class="category-box-icon d-flex">
								<i class="fas fa-spinner spinner"></i>
								</div>
						    </div>
						  </div>
					</div>
				</div>
				</form>
			</div>
			
		</div>
	</div>
</section>

<app-footer></app-footer>